import { axiosInstance } from '../utils';

interface Response {
  url: string;
}

interface Request {
  creationId: string;
}

export const getSharedVideoPresignedUrl = async ({ creationId }: Request): Promise<Response> => {
  const resp = await axiosInstance.get('/api/videos/get-shared-video', {
    params: { creationId },
  });
  return resp.data;
};
